import React from "react";
import "../style/page/OpenSource.css";
import { useOpenSourceContent } from "../hooks/useOpenSourceContent";
import OpenSourceTable from "../component/OpenSourceTable";

function OpenSource() {
  const { title, description, metaTitle, projects, headerTexts } = useOpenSourceContent();

  React.useEffect(() => {
    if (metaTitle) {
      document.title = metaTitle;
    }
  }, [metaTitle]);

  return (
    <main className="main-content open-source-page">
      <h4 className="page-title">{title}</h4>

      <p className="description" dangerouslySetInnerHTML={{ __html: description }} />

      <OpenSourceTable projects={projects} headerTexts={headerTexts} />
    </main>
  );
}

export default OpenSource;
